/** Título curto da sessão no prontuário — ex.: "Sessão 10/06". */
export const formatProntuarioSessionTitle = (
	selectedDate?: string | Date | null,
): string => {
	if (!selectedDate) return 'Sessão';

	const date = new Date(selectedDate);
	if (Number.isNaN(date.getTime())) return 'Sessão';

	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');

	return `Sessão ${day}/${month}`;
};
